const getUserType = () => {
  return [{ code: 'Admin', name: 'Admin' }, { code: 'User', name: 'User' }];
};

export default getUserType;
